import React, { Component } from 'react';
import { connect } from 'react-redux'
import {fetchThemen, selectThema, appendThemenNextPageAction} from '../actions/referenten/themen'
import { fetchReferenten } from '../actions/referenten/referenten'
import ThemenComponent from '../components/Themen'

class Themen extends Component
{
    componentDidUpdate(prevProps) {
        if (prevProps.selectedKreis !== this.props.selectedKreis
            || prevProps.selectedBezirk !== this.props.selectedBezirk
            || prevProps.filters.themen !== this.props.filters.themen
            || prevProps.filters.referenten !== this.props.filters.referenten
            || prevProps.filters.einsatzgebiet !== this.props.filters.einsatzgebiet) {
            this.props.dispatch(fetchThemen());
        }
    }

    render(){
        return <ThemenComponent themen={this.props.themen} referenten={this.props.referenten} selected={this.props.selected} selectThema={this.selectThema.bind(this)} appendThemenNextPage={this.appendThemenNextPage.bind(this)} themenAdding={this.props.themenAdding}/>
    }

    appendThemenNextPage(page) {
        this.props.dispatch(appendThemenNextPageAction(page));
    }

    selectThema(thema) {
        this.props.dispatch(fetchReferenten(thema));
        this.props.dispatch(selectThema(thema));
    }
}

const mapStateToProps = store => {
    return {
        themen: store.themen,
        themenAdding: store.themen.isAdding,
        selected: store.themen.selected,
        selectedKreis: store.kreise.selected,
        selectedBezirk: store.bezirke.selected,
        referenten: store.referenten,
        filters: store.filters,
    }
}

export default connect(mapStateToProps)(Themen)


// WEBPACK FOOTER //
// ./src/containers/Themen.js